module.exports = __webpack_public_path__ + "media/img/pwpush_logo-e02712363e8a4849ea6fb99babdeb965.png";